import React, { Component } from 'react';
import data from './data.json';
import './App.css';
import Home from './Pages/Home/Home';
import Header from './Pages/Home/navigation';
import {Route, Switch} from 'react-router-dom';
import {BrowserRouter} from 'react-router-dom'
import './style.css';
import Images from './Pages/Images/Images';
import Newsletter from './Pages/Newsletter/Newsletter';
import Videos from './Pages/Videos/Videos';
import { storage } from './firebase';
import PressReleases from './Pages/PressReleases/PressReleases';
import ContactUs from './Pages/ContactUs/ContactUs';
import Login from './Pages/Login/Login';
import firebaseApp from './firebase';
import Footer from './Pages/footer.component'

export class App extends Component {
  state = {
    landingPageData: {},
    admin: false,
    imageUrls: null,
    videoUrls: null,
    pdfUrls: null  ,
    user:""    ,
    press: null    
  }
  getlandingPageData() { 
    this.setState({landingPageData : data, 
                       imageUrls: null,
                       videoUrls: null,
                       pdfUrls: null  ,
                       user:""    ,
                       press: null    
    });
  }
  getImages(){
    const that=this;
    const IU=[];

     storage.ref("images").listAll().then(function(result){
        result.items.forEach(function(imageRef){
            // console.log("Image reference"+ imageRef);
            imageRef.getDownloadURL().then(function(url){
                console.log(url)
                IU.push(url);
                // that.setState({imageUrls: IU}
               
           that.setState({...that.state,imageUrls: IU}, ()=> console.log(''));
                
                // console.log(that.state)
  
            })
            
            
        })
       
    });

  }

  getVideos(){
    const that=this;
    const IU=[];

     storage.ref("videos").listAll().then(function(result){
        result.items.forEach(function(imageRef){
            // console.log("video reference"+ imageRef);
            imageRef.getDownloadURL().then(function(url){
                console.log(url)
                IU.push(url);
                // that.setState({imageUrls: IU}    
           that.setState({...that.state,videoUrls: IU}, ()=> console.log());
                
                // console.log(that.state)
  
            })
            
            
        })
       
    });

  }
  getPdfs(){
    const that=this;
    const IU=[];

     storage.ref("pdfs").listAll().then(function(result){
        result.items.forEach(function(imageRef){
            // console.log("Image reference"+ imageRef);
            imageRef.getDownloadURL().then(function(url){
                // console.log(url)
                IU.push(url);
                // that.setState({imageUrls: IU}
               
           that.setState({...that.state,pdfUrls: IU}, ()=> console.log());
                
                // console.log(that.state)
  
            })
            
            
        })
       
    });

  }
  // getPress(){
  //   const that=this;
  //   const IU=[];

  //    storage.ref("press").listAll().then(function(result){
  //       result.items.forEach(function(imageRef){
  //           // console.log("Image reference"+ imageRef);
  //           imageRef.getDownloadURL().then(function(url){
  //               // console.log(url)
  //               IU.push(url);
  //               // that.setState({imageUrls: IU}
               
  //          that.setState({...that.state,press: IU}, ()=> console.log());
                
  //               console.log(that.state)
  
  //           })
            
            
  //       })
       
  //   });

  // }
  componentDidMount() {
    this.getlandingPageData();
    this.getImages();
    this.getVideos();
    this.getPdfs();
    // this.getPress();
    const that = this;
    firebaseApp.auth().onAuthStateChanged(function(user) {
      if (user) {
       that.setState({admin:true})
      } 
      });
  }
  
 


  render() {
    console.log(this.state.press);
    return (
    <div className="intro">
     <BrowserRouter>
     <Header/>
     <Switch>
      <Route exact path='/' render={()=>(<Home />)}  />
      <Route exact path='/images' render={()=>(<Images admin={this.state.admin} data={this.state.imageUrls} />)}  />
      <Route exact path='/videos' render={()=>(< Videos admin={this.state.admin} data={this.state.videoUrls} />)}  />
      <Route exact path='/newsletter' render={()=>(<Newsletter admin={this.state.admin} data={this.state.pdfUrls} />)}  />
      {/* <Route exact path='/pressreleases' render={()=>(<PressReleases admin={this.state.admin} data={this.state.press} />)}  /> */}
      {/* <Route exact path='/contactus' render={()=>(<ContactUs data={this.state.pdfUrls} />)}  /> */}
      <Route exact path='/login' render={()=>(<Login  />)}  />    
     </Switch>
     {/* <Footer/> */}
   </BrowserRouter>
     
       
    </div>
  );
    }
}

export default App;
